import { render, staticRenderFns } from "./RfidMenuItem.vue?vue&type=template&id=0d9f65b7&scoped=true"
import script from "./RfidMenuItem.vue?vue&type=script&lang=js"
export * from "./RfidMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f65b7",
  null
  
)

export default component.exports